import React from "react";
import {interpolate, useCurrentFrame} from "remotion";
import {techLaunchData} from "../../../data/techLaunchData";


export const Ending: React.FC = () => {

  const frame = useCurrentFrame();


  const opacity = interpolate(
    frame,
    [0, 40],
    [0, 1],
    {
      extrapolateRight: "clamp",
    }
  );


  const scale = interpolate(
    frame,
    [0, 60],
    [0.7, 1],
    {
      extrapolateRight: "clamp",
    }
  );


  return (

    <div
      style={{
        flex:1,
        backgroundColor:"#000",
        color:"white",
        display:"flex",
        flexDirection:"column",
        justifyContent:"center",
        alignItems:"center",
        opacity,
        transform:`scale(${scale})`,
      }}
    >

      <h1
        style={{
          fontSize:100,
          margin:0,
        }}
      >
        {techLaunchData.ending}
      </h1>


      <p
        style={{
          marginTop:40,
          fontSize:48,
          opacity:0.7,
        }}
      >
        Powered by Remotion + AI
      </p>

    </div>
  );
};
